<template>
  <ElDialog :title="title" :visible="value" width="20%" @close="resetAndClose">
    <ElForm
      :ref="sendToEmailFormRef"
      :rules="rules"
      :model="sendToEmailModel"
      @submit.native.prevent="sendToEmail"
    >
      <ElFormItem :label="$t('EMAIL')" prop="email">
        <ElInput
          v-model="sendToEmailModel.email"
          class="text-latin"
          type="email"
          name="email"
          dir="ltr"
          required
        />
      </ElFormItem>
    </ElForm>

    <div slot="footer" class="dialog-footer">
      <ElButton type="primary" @click.native.prevent="sendToEmail">
        <i class="material-icons">
          email
        </i>
        <span>{{ title }}</span>
      </ElButton>
      <ElButton type="text" :plain="true" @click.native.prevent="resetAndClose">
        {{ $t('CANCEL') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import form from '@/mixins/form';
import required from '@/utils/validation-rules/required';

export default {
  name: 'AppSalesReportSendToEmailModal',

  mixins: [form],

  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      sendToEmailModel: {
        email: '',
      },
    };
  },

  computed: {
    rules() {
      return {
        email: {
          ...required(this.$t('INVALID_INPUT_VALUE_EMAIL')),
          type: 'email',
        },
      };
    },
    sendToEmailFormRef() {
      return 'sendToEmailFormRef';
    },
  },

  methods: {
    reset() {
      this.resetForm(this.sendToEmailFormRef);
    },
    resetAndClose() {
      this.reset();
      this.$emit('input', false);
    },
    sendToEmail() {
      this.resetAndClose();
      this.$emit('send-to-email', this.sendToEmailModel.email);
    },
  },
};
</script>
